import { Box } from '@mui/material'
import { CarrierType, JourneyCategory } from '@planning/app/api'
import { CargoSubFormSection } from '@planning/pages/VesselVisit/Components/BulkEdit/CargoSubForm/CargoSubFormSection'
import { InboundSubFormSection } from '@planning/pages/VesselVisit/Components/BulkEdit/InboundSubForm/InboundSubFormSection'
import { LogisticsSubFormSection } from '@planning/pages/VesselVisit/Components/BulkEdit/LogisticsSubForm/LogisticsSubFormSection'
import { OutboundSubFormSection } from '@planning/pages/VesselVisit/Components/BulkEdit/OutboundSubForm/OutboundSubFormSection'
import { observer } from 'mobx-react-lite'
import { RailVisitBulkEditFormStore } from '../../stores/RailVisitBulkEditFormStore'
import { RailVisitBulkEditViewStore } from '../../stores/RailVisitBulkEditViewStore'

interface BulkEditFormProps {
  formStore: RailVisitBulkEditFormStore
  viewStore: RailVisitBulkEditViewStore
}

export const RailVisitBulkEditForm = observer(({ formStore, viewStore }: BulkEditFormProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
      <InboundSubFormSection
        store={formStore.inboundTransport}
        viewStore={viewStore}
        category={JourneyCategory.None}
        defaultCarrierType={CarrierType.Train}
      />

      <OutboundSubFormSection
        store={formStore.outboundTransport}
        viewStore={viewStore}
        category={JourneyCategory.None}
        defaultCarrierType={CarrierType.Train}
      />

      <LogisticsSubFormSection store={formStore.logistics} category={JourneyCategory.None} />

      <CargoSubFormSection store={formStore.cargo} />
    </Box>
  )
})
